import Vue from 'vue';
const state = Vue.observable({
  settings: [],
  settingsParsed: []
});
export default state;
